<template>
    <!-- Layout container -->
    <div>
      <!-- Footer -->
      <footer class="content-footer footer bg-footer-theme">
        <div
          class="container-xxl d-flex flex-wrap justify-content-between py-2 flex-md-row flex-column"
        >
          <div class="mb-2 mb-md-0">
          </div>
          <div class=" text-center">
            © 2025, Powered by - &nbsp;
            <a
              href="https://phicsart.com"
              target="_blank"
              class="footer-link fw-bolder"
              > <img src="https://phicsart.com/uploads/images/top-page/menu/logo.svg" alt="" class="img-fluid " style="max-width: 13px;"> hicsArt  </a
            >
          </div>
        </div>
      </footer>
      <!-- / Footer -->
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'FooterView',
  components: {},
  data() {
    return {};
  },
  methods: {},
  setup() {
    return {};
  },
});
</script>
